﻿export default class CoordinateReferenceSystemSwitcherControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, siblingsBefore) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.siblingsBefore = siblingsBefore;
        this.control = null;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.switcherSelectId = 'switcher-select-' + this.classId + '-' + this.action.Id;
    }

    init() {
        if (this._isMobileDevice()) return;

        let div = document.createElement('div');

        let additionalSrs = this.mapControl.map.getView().getProjection().getCode();
        let additionalSrsAlias = null;

        if (additionalSrs == 'EPSG:3857') {
            additionalSrs = null;
        }

        if (additionalSrs == 'EPSG:4326') {
            additionalSrs = null;
        }

        if (additionalSrs == 'EPSG:3844') {
            additionalSrsAlias = 'Stereo 70';
        }

        div.innerHTML = this._getTemplate(additionalSrs, additionalSrsAlias);
        this.menuContainer.append(div.firstChild);

        $('#' + this.switcherSelectId)[0].value = this.mapControl.map.getView().getProjection().getCode();

        $('#' + this.switcherSelectId).on('change', (e) => {
            let value = e.target.value;
            this.mapControl.setProjection(value);
        })
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _getTemplate(additionalSrs, additionalSrsAlias) {
        return `<div id="` + this.elementId + `" class="crs-switcher-` + this.siblingsBefore + `">
                    <select id="` + this.switcherSelectId + `" style="height: 1.2rem;">
                      <option value="EPSG:4326">WGS84</option>
                      <option value="EPSG:3857">Web Mercator</option>`
                      + (additionalSrs != null ? `<option value="` + additionalSrs + `">` + (additionalSrsAlias != null ? additionalSrsAlias : additionalSrs)  + `</option>` : ``) +
                    `</select>
                </div>`;
    }
}